import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IStore, IStoreChange } from "src/models/Stores/Store.models";

interface StoreState {
  stores: IStore[];
  storeToEdit: IStore | null;
}

const initialState: StoreState = {
  stores: [],
  storeToEdit: null,
};

const storeSlice = createSlice({
  name: "Store",
  initialState,
  reducers: {
    setStoreList: (state, action: PayloadAction<IStore[]>) => {
      state.stores = action.payload;
    },
    concatListStore: (state: StoreState, action: PayloadAction<IStore[]>) => {
      state.stores = [...state.stores.concat(action.payload)];
    },
    setStoreToEdit: (state, action: PayloadAction<IStore | null>) => {
      state.storeToEdit = action.payload;
    },
    addStore: (state, action: PayloadAction<IStore>) => {
      state.stores.push(action.payload);
    },
    addStores: (state, action: PayloadAction<IStore[]>) => {
      state.stores.push(...action.payload);
    },
    updateStore: (state, action: PayloadAction<IStore>) => {
      let itemIndex = state.stores.findIndex(
        item => item.storeId === action.payload.storeId
      );
      if (itemIndex !== -1) state.stores[itemIndex] = action.payload;
    },
    updateStoreChanges: (state, action: PayloadAction<IStoreChange[]>) => {
      if (state.storeToEdit !== null) {
        if(state.storeToEdit.changes != null)
          state.storeToEdit.changes?.push(...action.payload);
        else state.storeToEdit.changes = action.payload;
      }
    },
    deleteStore: (state, action: PayloadAction<number>) => {
      const newArray = state.stores.filter(
        item => item.storeId !== action.payload
      );
      state.stores = newArray;
    },
  },
});

export const {
  setStoreList,
  concatListStore,
  setStoreToEdit,
  addStore,
  addStores,
  updateStore,
  updateStoreChanges,
  deleteStore,
} = storeSlice.actions;

export default storeSlice.reducer;
